export enum ImagePreset {
  Thumbnail = 'Thumbnail-150x150px',
  Small = 'Small-250x250px',
  Preview = 'Preview-350x350px',
  Default = 'Default-650x650px',
  Big = 'Big-850x850px'
}

export enum ImageUrlType {
  Small = 'externalUrlSmall',
  Large = 'externalUrlLarge'
}
